import { useGetHttp } from "../../http.hook";

interface IMetrics {
  count: number;
  totalFollowers: number;
  averageFollowers: number;
  totalViews: number;
  averageViews: number;
  totalEngagementRate: number;
  averageEngagementRate: number;
}

interface IBreakdown {
  mega: number;
  macro: number;
  midTier: number;
  micro: number;
  nano: number;
  pico: number;
}

export interface IFavoriteMetrics {
  creators: {
    count: number;
    breakdown: IBreakdown;
  };
  followers: {
    count: number;
    breakdown: IBreakdown;
  };
  views: {
    average: number;
    breakdown: IBreakdown;
  };
  engagement: {
    average: number;
    breakdown: IBreakdown;
  };
  genderSplit: Record<string, number>;
  genreSplit: Record<string, number>;
  tierWiseSplit: {
    mega: IMetrics;
    macro: IMetrics;
    midTier: IMetrics;
    micro: IMetrics;
    nano: IMetrics;
    pico: IMetrics;
  };
}

interface IResponse {
  metrics: IFavoriteMetrics;
}

export function useGetMetricsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/:favoriteId/metrics",
  });
}
